require('./index.less');
var tpl = require('./index.html');
var locale = require('../../i18n');

var manager = {
    init: function() {
        // TODO: Extract variables from current window controller code
        // to update variable list when user select this tab.

        $('#variable-management').html(tpl({
            locale: locale()
        }));
        
        $('#add-dep-var').button({
            icons: {
                primary: 'ui-icon-plus'
            }
        });
        $('#add-sup-var').button({
            icons: {
                primary: 'ui-icon-plus'
            }
        });

        $("#supported-var-type").selectmenu({
            width: 80
        });

        Enhancer.VariableManager.getAllCurrSupportedVariableList(function(varList) {
            $( "#dependent-var" ).autocomplete( {
                source: varList
            } );
        });
        
        this.$dependentList = $('.dependent-vars-list');
        this.$supportedList = $('.supported-vars-list');

        this.__bindEvent();
    },
    __bindEvent: function() {
        var that = this;
        $('#variable-management').on('click', function(e) {
            if (e.target.tagName === 'I' 
                && $(e.target).hasClass('ui-icon-minus')) {
                $(e.target).parent().parent().remove();
            }
        });

        $('#add-sup-var').on('click', function() {
            var name = $('#supported-var').val();
            if (!/^\w+$/.test(name)) {
                $('#supported-var').effect('highlight');
                return;
            }
            var $li = that.$supportedList.find('li[name=' + name + ']');
            if ($li.size()) {
                $li.effect('highlight');
                $('#supported-var').effect('highlight');
                return;
            }
            $('<li class="ui-widget-content">')
                .attr('name', name)
                .append($('<span class="name">').text(name))
                .append($('<span class="type">').text($('#supported-var-type').val()))
                .append($('<span class="des">').text($('#supported-var-des').val()))
                .append('<span class="ui-widget-content"><i class="ui-icon ui-icon-minus"></i></span>')
                .appendTo(that.$supportedList);

            $('#supported-var').val('');
            $('#supported-var-des').val('')
        });
            
        $('#add-dep-var').on('click', function() {
            var name = $('#dependent-var').val();
            if (!/^\d+-\w+$/.test(name)) {
                $('#dependent-var').effect('highlight');
                return;
            }

            var $li = that.$dependentList.find('li[name=' + name + ']');
            if ($li.size()) {
                $li.effect('highlight');
                $('#dependent-var').effect('highlight');
                return;
            }
            $('<li class="ui-state-default">')
                .attr('name', name)
                .append($('<label>').text(name))
                .append('<span class="ui-widget-content"><i class="ui-icon ui-icon-minus"></i></span>')
                .appendTo(that.$dependentList);
            $('#dependent-var').val('');
        });
    },
    setDependentVariableList: function(list) {
        var that = this;
        that.$dependentList.html('');
        list = list || [];
        var name;
        for (var i = 0; i < list.length; i++) {
            name = list[i];
            $('<li class="ui-state-default">')
                .attr('name', name)
                .append($('<label>').text(name))
                .append('<span class="ui-widget-content"><i class="ui-icon ui-icon-minus"></i></span>')
                .appendTo(that.$dependentList);
        }
        Enhancer.VariableManager.getAllCurrSupportedVariableList(function(varList) {
            $( '#dependent-var' ).autocomplete( 'option', 'source', varList );
        });
    },
    getDependentVariableList: function() {
        return this.$dependentList
            .find('li')
            .map(function() {
                return $(this).attr('name');
            }).get();
    },
    setSupportedVariableList: function(list) {
        this.$supportedList.html('');
        list = list || [];
        for (var i = 0; i < list.length; i++) {
            $('<li class="ui-widget-content">')
                .append('<span class="name">' + list[i].name + '</span>')
                .append('<span class="type">' + list[i].type + '</span>')
                .append('<span class="des">' + list[i].des + '</span>')
                .append('<span class="ui-widget-content"><i class="ui-icon ui-icon-minus"></i></span>')
                .appendTo(this.$supportedList);
        }

    },
    getSupportedVariableList: function() {
        return this.$supportedList
            .find('li')
            .map(function() {
                var $this = $(this);
                return {
                    name: $this.find('span.name').text(),
                    type: $this.find('span.type').text(),
                    des: $this.find('span.des').text()
                };
        }).get();
    }
};

module.exports = manager;



/*****************
 ** WEBPACK FOOTER
 ** ./src/managers/variable/index.js
 ** module id = 30
 ** module chunks = 0
 **/